// Dynamic Configs
export const dynamicConfig = 'telehealth_config';
export const blockedTelehealthPatientShortIds = 'blocked_telehealth_patient_short_ids';
export const announcementConfig = 'telehealth_announcement';
export const aiManualQaProviders = 'ai_qa_opted_in_providers';
export const retryConfigForClientMissingRequiredConsentsQuery =
  'retry_config_for_client_missing_required_consents_query';

// Feature Gates
export const whiteboardEnabledGate = 'telehealth_whiteboard_enabled';
export const aiAssistedPrescriberNotesGate = 'ai_assisted_prescriber_notes';
export const disableTranscriptionForMultipleParticipants = 'telehealth_disable_transcription_for_multiple_participants';
export const toastViewTransitionsGate = 'telehealth_toast_view_transitions';
export const whiteboardEventualConsistencyGate = 'telehealth_whiteboard_eventual_consistency';
export const wordpressUrlMigrationGate = 'wordpress_url_migration';
export const blockInvalidUrlsGate = 'telehealth_block_invalid_urls';
export const waitingRoomTimeoutGate = 'telehealth_waiting_room_timeout';
export const providerPatientReflectionsUIEnabledGate = 'provider_patient_reflections_ui_enabled';
export const enableZoomGate = 'telehealth_enable_zoom';
export const providerWaitingRoomTranscriptionConsentModalGate = 'provider_waiting_room_transcription_consent_modal';
export const providerCustomDomainGate = 'provider_custom_domain';
export const telehealthRequiredConsentsWaitingRoomBlockGate = 'telehealth_required_consents_waiting_room_block';
export const showClientCocBannerGate = 'show_client_coc_banner';
export const telehealthRejoinRoomGate = 'telehealth_rejoin_room';
export const shouldShowPiiAuthFlowGate = 'should_show_pii_auth_flow';
export const telehealthLogOutUnauthorizedClientsGate = 'telehealth_log_out_unauthorized_clients';
export const telehealthVisitorRouteRedirectGate = 'telehealth_visitor_route_redirect';
export const localizationTelehealthClientGate = 'localization_telehealth_client';
export const localizationTelehealthClientPromptGate = 'localization_telehealth_client_prompt';
export const telehealthRecordingPromptForMinorsGate = 'telehealth_recording_prompt_for_minors';
export const telehealthVisuallyDistinctPausedRecordingControlGate =
  'telehealth_visually_distinct_paused_recording_control';
export const showAnytimeCSSRSGate = 'show_anytime_cssrs';
export const showKaiserIntakeCSSRSGate = 'show_kaiser_intake_cssrs';
export const showChildCSSRSGate = 'show_child_cssrs';
export const telehealthBranchSmartBannersGate = 'telehealth_branch_smart_banners';
export const arc2026Rebrand = '2026-h2_rebrand';
export const telehealthZoomLiveTranscriptionEnabledGate = 'telehealth_zoom_live_transcription_enabled';
export const telehealthAdmitStatusIndicatorGate = 'telehealth_admit_status_indicator';
export const telehealthSoftBlockEnabledGate = 'telehealth_soft_block_enabled';
export const eprescribeEnabledGate = 'eprescribe_enabled';
export const telehealthMeetingGridLayoutGate = 'telehealth_meeting_grid_layout';
